 
/* eslint-disable new-cap */
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';

export default function PakItemViewModel(model, accountId) {
    ko.mapping.fromJS(model, {}, this);

    this.AccountId = accountId;
    this.doseTypeDisplay = getDoseTypeDisplay(this.DoseType());
    this.discountedPrice = this.DiscountedPrice().toFixed(2);
    this.fullPrice = this.ConditionalItemFullCharge().toFixed(2);

    this.discountsApplied = Object.keys(this.Discounts).map(
        function(key) {
            return key + ': $' + parseFloat(this.Discounts[key]()).toFixed(2);
        }.bind(this)
    );

    this.discountsAppliedTooltip = this.discountsApplied.length
        ? '<strong>Your savings</strong>:<br />' + this.discountsApplied.join('<br />')
        : '';
    this.discountsAppliedTitle = this.discountsApplied.length
        ? 'Your savings: ' + this.discountsApplied.join(', ')
        : '';
    this.hasDiscounts = this.discountsApplied.length > 0;
    this.discountCodesApplied = Object.keys(this.Discounts).join(', ');
}


function getDoseTypeDisplay(doseType) {
    var CUSTOM = 1997690860,
        LOADING = 1997690859,
        MAINTENANCE = 1997690858;

    if (doseType === CUSTOM) {
        return 'Custom';
    } else if (doseType === LOADING) {
        return 'Loading';
    } else if (doseType === MAINTENANCE) {
        return 'Maintenance';
    }
    return '';
}

